export const COLOR = {
    BASE: {
        PAGE: '#020b22',
        DIVIDER: '#293040',
        DIVIDER2: '#666d7b',
        SCRIM_LIGHT: 'rgba(0, 0, 0, 0.6)',
        SCRIM_DARK: 'rgba(0, 0, 0, 0.8)',
        SHADOW_SHORT: 'rgba(0, 0, 0, 0.3)',
        SHADOW_LONG: 'rgba(0, 0, 0, 0.5)',
    },
    BRAND: {
        BACKGROUND1: '#020b22',
        BACKGROUND2: '#ffffff',
        BACKGROUND3: '#c4c9d2',
        BACKGROUND4: '#2e364d',
        BACKGROUND5: '#5b627c',
        BACKGROUND6: '#e5e7ea',
        BACKGROUND7: '#afb4bd',
        BACKGROUND8: '#030917',
        FOREGROUND1: '#ffffff',
        FOREGROUND2: '#00e589',
        FOREGROUND3: '#c9ccd1',
        FOREGROUND4: '#020b22',
        FOREGROUND5: '#5b627c',
        FOREGROUND6: '#2e364d',
        FOREGROUND7: '#8c93af',
        ACCENT1: '#00e589',
        ACCENT2: '#ffe13e',
        ACCENT3: '#0004ff',
        CTA1: '#00e589',
        CTA2: '#ffe13e',
    },
    SEMANTIC: {
        ERROR1: '#ff3434',
        ERROR2: '#ff8b8b',
        WARNING1: '#ffe13e',
        WARNING2: '#fff09f',
        SUCCESS1: '#41f4ac',
        SUCCESS2: '#b1fedf',
    },
    RESERVED: {
        BLACK: '#2d2d2e',
        WHITE: '#f9f9f9',
        TRANSPARENT: 'rgba(249, 249, 249, 0)',
        ACCENT: '#000',
    },
};

export const FONT = {
    FAMILY: 'Lato, sans-serif',
    FAMILY_FUTURA: 'FuturaPT, sans-serif',

    WEIGHT_NORMAL: 400,
    WEIGHT_SEMI_BOLD: 700,
    WEIGHT_BOLD: 900,

    WEIGHT_FUTURA_BOLD: 700,

    SIZE_XXSMALL: 11,
    SIZE_XSMALL: 12,
    SIZE_SMALL: 13,
    SIZE_MEDIUM: 14,
    SIZE_LARGE: 16,
    SIZE_XLARGE: 18,
};

export const BASIC_PALETTE = {
    FONT_FAMILY: 'Lato, sans-serif',

    FONT_HEADER4: {
        fontFamily: FONT.FAMILY_FUTURA,
        fontSize: FONT.SIZE_LARGE,
        fontWeight: FONT.WEIGHT_FUTURA_BOLD,
        textTransform: 'uppercase',
        fontStyle: 'italic',
    },

    FILL_PAGE: COLOR.BASE.PAGE,
    FILL_HEADER: COLOR.BASE.PAGE,
    FILL_HERO: COLOR.BASE.PAGE,
    FILL_SHEET: COLOR.BRAND.BACKGROUND1,
    FILL_POPOVER: COLOR.BRAND.FOREGROUND7,

    FILL_CONTENT_DEFAULT: COLOR.BASE.PAGE,
    FILL_CONTENT_PROMINENT: COLOR.BASE.PAGE,

    FILL_CARD: COLOR.BRAND.BACKGROUND3,
    FILL_CARD_PROMINENT: COLOR.BRAND.BACKGROUND3,

    FILL_CONTROL_OUTLINE: `${COLOR.BRAND.FOREGROUND4}|${COLOR.BRAND.FOREGROUND1}`,
    FILL_CONTROL_ACCENT: COLOR.BRAND.CTA1,
    FILL_CONTROL_ODDS: COLOR.BRAND.BACKGROUND5,

    FILL_ACCENT_PRIMARY: '#00e589',
    FILL_ACCENT_SECONDARY: '#ffe13e',
    FILL_ACCENT_FOCUS: COLOR.BRAND.ACCENT2,

    FILL_SELECTED_PRIMARY: COLOR.BRAND.CTA1,
    FILL_SELECTED_ODDS: COLOR.BRAND.CTA1,

    DEFAULT_PRIMARY_TEXT: `${COLOR.BRAND.FOREGROUND4}|${COLOR.BRAND.FOREGROUND1}`,
    DEFAULT_SECONDARY_TEXT: `${COLOR.BRAND.FOREGROUND3}|${COLOR.BRAND.FOREGROUND6}`,

    TEXT_ODDS_PRIMARY: '#ffffff',
    TEXT_ODDS_SECONDARY: '#ffffff',

    TEXT_ACCENT_PRIMARY: '#2e364d',
    TEXT_ACCENT_SECONDARY: '#2e364d',
    TEXT_ACCENT_FILL: '#5b627c',

    TEXT_SELECTED_ODDS: COLOR.BRAND.FOREGROUND4,

    DEFAULT_GENERIC_ACCENT_COLOR: COLOR.BRAND.CTA2,
    DEFAULT_DIVIDER: COLOR.BASE.DIVIDER,

    DEFAULT_BUTTON_BORDER_RADIUS: 4,
};
